import React, { useState } from 'react';
import Visibility from '@spectrum-icons/workflow/Visibility';
import VisibilityOff from '@spectrum-icons/workflow/VisibilityOff';
import classNames from 'class-names';
import style from './PasswordField.module.less';

/**
 * @param {{ validationText?: string; validationState: "invalid" | "valid"; label: string; placeholder: string; value?: string; onChange: (a: string) => void }} props
 */
export default function PasswordField(props) {
  const [isTextHidden, setIsTextHidden] = useState(true);

  return (
    <div className={style.inputContainer}>
      {props.label ? <span className={style.label}>{props.label}</span> : null}
      <div className={style.textFieldContainer}>
        <input
          className={classNames({ [style.warningInputContainer]: props.validationState !== 'valid', [style.input]: true })}
          type={isTextHidden ? 'password' : 'text'}
          placeholder={props.placeholder}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
        <Icon isTextHidden={isTextHidden} onClick={() => setIsTextHidden(!isTextHidden)} />
      </div>
      {props.validationText && <span className={style.validation}>{props.validationText}</span>}
    </div>
  );
}

/**
 * @param {{ isTextHidden: boolean; onClick: Function }} props
 */
const Icon = (props) => {
  if (props.isTextHidden) {
    return (
      <span className={style.icon} onClick={() => props.onClick()}>
        <Visibility />
      </span>
    );
  }
  if (!props.isTextHidden) {
    return (
      <span className={style.icon} onClick={() => props.onClick()}>
        <VisibilityOff />
      </span>
    );
  }
  return null;
};
